module.exports = __webpack_public_path__ + "static/media/progress_bar_0_active.3b88f58d.svg";